module.exports = __webpack_public_path__ + "img/load_room.52e9dd20.png";